<template>
    <div>
        <b-field
            :label="title"
            class="mb-0">
            <div class="columns">
                <div class="column pb-0 pt-1">
                    <slot
                        class="column"
                        name="params"></slot>
                </div>
            </div>
        </b-field>
        <slot name="times"></slot>
        <div class="mt-3">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
  export default {
    name: "FormTimetableDayWrapper",
    props: {
      title: {
        type: String,
        default: null
      }
    }
  };
</script>

<style scoped>

</style>
